"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "family", {
  enumerable: true,
  get: function get() {
    return _family["default"];
  }
});
Object.defineProperty(exports, "size", {
  enumerable: true,
  get: function get() {
    return _size["default"];
  }
});
Object.defineProperty(exports, "weight", {
  enumerable: true,
  get: function get() {
    return _weight["default"];
  }
});

var _family = _interopRequireDefault(require("./family"));

var _size = _interopRequireDefault(require("./size"));

var _weight = _interopRequireDefault(require("./weight"));